import { buildMakeUseAxios } from "@api";
import type { IFormation } from "@bbj-types/formation";
import { useCallback } from "react";

const formationAxios = buildMakeUseAxios(`${import.meta.env.VITE_SETTING_SERVICE_URL}/formations`);

export interface IGetFormationFilters {
  limit?: number;
  skip?: number;
  search: string;
}

export interface IGetFormation {
  limit: number;
  skip: number;
  count: number;
  total: number;
  data: readonly IFormation[];
}

export const useGetFormations = () => {
  const [state, execute, cancel] = formationAxios<IGetFormation, void, unknown>(
    {
      url: "",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (filters: IGetFormationFilters) => {
      return execute({
        params: filters,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
